import axios from "../http";
import {Y_TOKEN, Y_W_USER} from "../utils/Var";
import qs from "qs"

const appid = process.env.VUE_APP_ID
console.log(appid)
console.log('-----------')
const scope = ['snsapi_base', 'snsapi_userinfo']
let locationUrl = window.location.href
let webUrl = locationUrl.split("?")[0]
export default function () {
    return new Promise(async resolve => {
        let query = qs.parse(locationUrl.split('?')[1])
        console.log(query)
        console.log('------------')
        if (query.code) {
            const res = await axios.post("/wechat_login", {
                code: query.code,
            });
            if (res.code == 1) {
                localStorage.setItem(Y_TOKEN, res.data.token);
                resolve();
            } else {
                delete query.code
                delete query.state
                webUrl = webUrl + qs.stringify(query)
                hrefLogin(webUrl)
                return
            }
        } else {
            hrefLogin(locationUrl)
        }
    })
}

//防止登录时，多次在url沙上添加code
function hrefLogin(redirectUrl) {
    redirectUrl = encodeURIComponent(redirectUrl)
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope[1]}#wechat_redirect`
}